<div class="tw-w-full tw-bg-black tw-rounded-t-lg md:tw-rounded-t-[90px] tw-z-20 tw-border-t-[#F67011] tw-border-t-2">
  <div class="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-8">
    <!-- Menú superior -->
    <div class="tw-hidden md:tw-flex md:tw-flex-wrap tw-justify-center md:tw-justify-end tw-mb-4 tw-gap-4">
      <h4 class="tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
        <a href="/"
          class="tw-no-underline tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
          INICIO
        </a>
      </h4>
      <h4 class="tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
        <a href="/servicios"
          class="tw-no-underline tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
          SERVICIO
        </a>
      </h4>
      <h4 class="tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
        <a href="/nosotros"
          class="tw-no-underline tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
          NOSOTROS
        </a>
      </h4>
      <h4 class="tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
        <a href="/contacto"
          class="tw-no-underline tw-text-white tw-cursor-pointer hover:tw-text-orange-400 tw-transition-colors">
          CONTACTO
        </a>
      </h4>
    </div>

    <!-- Contenido principal -->
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8 tw-text-white tw-mt-2">
      <!-- Columna 1 (Logo e info) -->
      <div class="tw-space-y-2 tw-text-center md:tw-text-left">
        <img src="assets/images/logofooter.png" class="tw-h-10 md:tw-h-14 tw-mx-auto md:tw-mx-0" />
        <h6 class="tw-text-[#F67011] md:tw-text-lg">
          UNIENDO A NUESTRA GENTE
        </h6>
        <h6 class="tw-text-white md:tw-text-lg">Mi internet es Onelink</h6>
      </div>

      <!-- Columna 2 (Contacto) -->
      <div class="tw-space-y-2 tw-text-center md:tw-text-right md:tw-pl-8">
        <h6 class="tw-text-white md:tw-text-lg hover:tw-text-orange-400 tw-transition-colors">
          <a class="tw-text-white tw-decoration-transparent hover:tw-text-orange-400 tw-transition-colors"
            href="mailto:info@onelink.net.ve" target="_blank">
            info&#64;onelink.net.ve
          </a>
        </h6>
        <h6 class="tw-text-white md:tw-text-lg hover:tw-text-orange-400 tw-transition-colors">
          <a class="tw-text-white tw-decoration-transparent hover:tw-text-orange-400 tw-transition-colors"
            href="https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+estoy+interesado+en+el+servicio+de+internet+por+fibra+%C3%B3ptica&type=phone_number&app_absent=0"
            target="_blank">
            +58 281-3169200
          </a>
        </h6>
        <h6
          class="tw-text-white md:tw-text-sm tw-text-balance tw-uppercase hover:tw-text-orange-400 tw-transition-colors">
          <a class="tw-text-white tw-decoration-transparent hover:tw-text-orange-400 tw-transition-colors"
            href="https://maps.app.goo.gl/9GK4PoLV1UfYKexHA" target="_blank">
            Av. Intercomunal Andrés Bello C.C. Vistamar, Nivel PB, Local 16
            Urb. Ciudad Lechería, Anzoátegui Zona Postal 6001
          </a>
        </h6>

        <h6
          class="tw-text-white md:tw-text-sm tw-text-balance hover:tw-text-orange-400 tw-transition-colors">
          <a class="tw-text-white tw-decoration-transparent hover:tw-text-orange-400 tw-transition-colors"
            href="/politica-privacidad">
            Política de Privacidad
          </a>
        </h6>

      </div>
    </div>

    <!-- Divider -->
    <div class="tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-[#F67011] tw-to-transparent tw-w-full tw-my-6">
    </div>

    <!-- Copyright -->
    <div class="tw-text-center tw-text-gray-400 tw-text-xs">
      <p>© {{ year }} Todos los derechos reservados.</p>
    </div>
  </div>
</div>